import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function Socios({
  socios,
  showRestricao,
  isConsultaNova,
}: {
  socios: any;
  showRestricao: boolean;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  if (isConsultaNova) {
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: '#EFF6FF',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i className="pi pi-users" style={{ color: '#2563EB', fontSize: '18px' }} />
          </div>
          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
              {t('socios')}
            </h3>
            {socios?.length > 0 && (
              <span style={{ fontSize: 'small', color: '#6B7280' }}>
                {socios.length} sócio{socios.length !== 1 ? 's' : ''} encontrado{socios.length !== 1 ? 's' : ''}
              </span>
            )}
          </div>
        </div>

        {/* Table */}
        <div style={{ overflowX: 'auto', borderRadius: '10px', border: '1px solid #F3F4F6' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 'small' }}>
            <thead>
              <tr style={{ backgroundColor: '#F9FAFB', borderBottom: '2px solid #E5E7EB' }}>
                {[
                  t('documento'),
                  t('status'),
                  t('nome'),
                  t('tipo'),
                  t('participacao'),
                  t('dataEntrada'),
                  t('dataAtualizacao'),
                  t('qsaAtualizado'),
                  ...(showRestricao ? [t('restricao')] : []),
                ].map(h => (
                  <th
                    key={h}
                    style={{
                      padding: '10px 14px',
                      fontWeight: 700,
                      color: '#6B7280',
                      fontSize: '0.7rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.04em',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {socios && socios.map((socio: any, idx: number) => (
                <tr
                  key={idx}
                  style={{ borderBottom: idx < socios.length - 1 ? '1px solid #F3F4F6' : 'none' }}
                  onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#EFF6FF')}
                  onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  <td style={{ padding: '10px 14px', color: '#374151', fontFamily: 'monospace' }}>{socio.documento}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <span
                      style={{
                        backgroundColor: '#DBEAFE',
                        color: '#1E40AF',
                        fontSize: '0.7rem',
                        fontWeight: 700,
                        padding: '2px 8px',
                        borderRadius: '4px',
                      }}
                    >
                      {socio.status}
                    </span>
                  </td>
                  <td style={{ padding: '10px 14px', fontWeight: 600, color: '#1F2937' }}>{socio.nome}</td>
                  <td style={{ padding: '10px 14px', color: '#374151' }}>{socio.tipo}</td>
                  <td style={{ padding: '10px 14px', color: '#374151' }}>{socio.participacao}</td>
                  <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{socio.dataInicio}</td>
                  <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{socio.dataAtualizacao}</td>
                  <td style={{ padding: '10px 14px', color: '#374151' }}>{socio.qsaAtualizado}</td>
                  {showRestricao && (
                    <td style={{ padding: '10px 14px' }}>
                      <span
                        style={{
                          backgroundColor: '#DBEAFE',
                          color: '#1E40AF',
                          fontSize: '0.7rem',
                          fontWeight: 700,
                          padding: '2px 8px',
                          borderRadius: '4px',
                        }}
                      >
                        {socio.statusRestricao || '—'}
                      </span>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // Legacy layout
  return (
    <Panel header={t('socios')}>
      <DataTable size="small" value={socios} tableStyle={{ minWidth: '50rem' }}>
        <Column field="documento" header={t('documento')}></Column>
        <Column field="status" header={t('status')}></Column>
        <Column field="nome" header={t('nome')}></Column>
        <Column field="tipo" header={t('tipo')}></Column>
        <Column field="participacao" header={t('participacao')}></Column>
        <Column field="dataInicio" header={t('dataEntrada')}></Column>
        <Column field="dataFim" header={t('dataSaida')}></Column>
        <Column field="dataAtualizacao" header={t('dataAtualizacao')}></Column>
        <Column field="qsaAtualizado" header={t('qsaAtualizado')}></Column>
        {showRestricao && (<Column field="statusRestricao" header={t('restricao')}></Column>)}
      </DataTable>
    </Panel>
  );
}
